import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";

import PurchasesTableHading from "./PurchasesTableHeading";
import PurchasesTableItem from "./PurchasesTableItem";

import NewsRequests from "services/news";

const PurchasesTable = ({ searchMode, searchInput }) => {
  const { purchaseList, purchasesTotalPages, purchasesCurrentPage } = useSelector(
    ({ news }) => news
  );
  const dispatch = useDispatch();

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(NewsRequests.getAllPurchases(value, searchInput));
    } else {
      dispatch(NewsRequests.getAllPurchases(value));
    }
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {purchaseList && purchaseList.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <PurchasesTableHading />
          </TableHead>
          <TableBody>
            {purchaseList.map((item) => (
              <PurchasesTableItem data={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
      {purchaseList.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={purchasesTotalPages}
            color="primary"
            page={purchasesCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default PurchasesTable;